import { jsx } from 'react/jsx-runtime';
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { useRect } from '@reach/rect';
import { useTabsContext, Tab } from '@reach/tabs';
import clsx from 'clsx';
import { ButtonBase } from '../ButtonBase/ButtonBase.js';
import styles from './Item.module.css.js';
import { useAnimationContext } from './use-animation-context.js';

// This workaround fix the useLayoutEffect warning on SSR.
// https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
function Item(props) {
  const [showChild, setShowChild] = useState(false);
  // Wait until after client-side hydration to show
  useEffect(() => {
    setShowChild(true);
  }, []);
  if (!showChild) {
    return null;
  }
  return jsx(ItemComponent, {
    ...props
  });
}
function ItemComponent({
  index,
  className,
  ...props
}) {
  const {
    selectedIndex
  } = useTabsContext();
  const isSelected = selectedIndex === index;
  // Measure the size of our element, only listen to rect if active
  const ref = useRef(null);
  const rect = useRect(ref, {
    observe: isSelected
  });
  // Get the style changing function from context
  const {
    setActiveRect
  } = useAnimationContext();
  // Update styles whenever we're active
  useLayoutEffect(() => {
    if (isSelected) {
      setActiveRect?.(rect);
    }
  }, [isSelected, rect, setActiveRect]);
  return jsx(Tab, {
    ...props,
    as: ButtonBase,
    ref: ref,
    className: clsx('box-border transition-all duration-hover', className, styles.tabHover, {
      [`${styles.selected}`]: isSelected
    }),
    type: "button"
  });
}

export { Item };
